<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="邀请面试"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       
        <el-form-item label="面试职位" prop="job_id" >
           <el-select
                v-model="formData.job_id" 
                placeholder="请选择入职职位"
                clearable
                filterable
                style="width:100%"
              >
              <el-option
                v-for="item in jobList"
                :key="item.job_id"
                :label="item.title"
                :value="item"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="面试时间" prop="audit_at" >  
          <el-date-picker
            v-model="formData.audit_at"
            type="datetime"
            placeholder="选择面试时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="面试地点" prop="address">
          <el-input v-model="formData.address" @focus="selectPoint" placeholder="选择面试地点" readonly></el-input>
        </el-form-item>


        <el-form-item label="联系人	" prop="person_name" >
          <el-input  type="text" v-model="formData.person_name" ></el-input>
        </el-form-item>


        <el-form-item label="联系方式	" prop="person_phone" >
          <el-input  type="number" v-model="formData.person_phone" maxlength="11"></el-input>
        </el-form-item>


        <el-form-item label="面试通知" prop="mark">
          <el-input type="textarea" v-model="formData.mark"></el-input>
        </el-form-item>
       
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>

    <select-point-dialog ref="mapDialog"  @setAddress="setAddress"></select-point-dialog>

  </el-dialog>
</template>

<script>
import selectPointDialog from "@/components/map/select-point-dialog.vue";

import { jobList,auditAdd} from "@/api/chat/index";

export default {
  components: { selectPointDialog},

  data() {
    return {
      visible: false,
      jobList:[],
      selectedJob:null,
      selectedJob:{},

      formData: {
        user_app_id:"",
        audit_at: "",
        job_id:"",
        lat:"",
        lng:"",
        address: "",
        person_name: "",
        person_phone: "",
        mark:''
       
      },
       rules: {
        
        job_id: [
              {required: true, message: '请选择职位', trigger: 'change'}
          ],
          audit_at: [
              {required: true, message: '请选择面试时间', trigger: 'blur'}
          ],
          address: [
              {required: true, message: '请输入面试地点', trigger: 'change'}
          ],
          person_phone: [
              {required: true, message: '请输入联系方式', trigger: 'blur'}
          ],
          person_name: [
              {required: true, message: '请输入联系人', trigger: 'blur'}
          ],
          mark: [
              {required: true, message: '请填写面试通知', trigger: 'blur'}
          ]

       }
    };
  },

 
  mounted() {

},
destroyed(){
},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.selectedJob=null;
      this.visible = false;

    },


    init(user_app_id) {
      console.log(user_app_id);
      this.visible = true;
      this.formData.user_app_id=user_app_id;
      this.initJobList();

    },

    initJobList(){
      var that = this;
      jobList({}).then((response) => {
        that.jobList = response.data;
      });
    },




    selectPoint(){
      this.$refs.mapDialog.init();
    },

    setAddress(data){
      console.log(data)
      this.formData.lat=data.lat;
      this.formData.lng=data.lng;
      this.formData.address=data.address;
      
    },
    
    submit(){
      var that=this;
      if(this.formData.lat === '' || this.formData.lng === ''){
            this.$message.error('请先选择地址！');
            return;
        }

      this.$refs["form"].validate((valid) => {
          if (valid) {
            auditAdd(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
                var enroll_id=response.enroll_id;
                that.$emit('callback',12,enroll_id);

                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
